const loadGoogleFont = (fontFamily) => {
	if (!fontFamily || fontFamily === 'inherit') {
		return;
	}	
	const fontId = `google-font-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
	const existingLink = document.getElementById(fontId);
	if (existingLink) {
		return;
	}	
	const link = document.createElement('link');
	link.id = fontId;
	link.rel = 'stylesheet';
	link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s+/g, '+')}:wght@300;400;500;600;700&display=swap`;
	document.head.appendChild(link);
};
export default loadGoogleFont;
